import { computed, ref, shallowRef, watch } from 'vue';
import { getTrialRenderConfig } from './getTrialRenderConfig';
import { type TrialInfo, getTrialInfoFromLiveCall } from './getTrialInfoFromLiveCall';
import { showWarningPopupDialog } from '@/use/swalDialog';

export const trialInfo = shallowRef<null | TrialInfo>(null);
export const trialRenderConfig = computed(() => getTrialRenderConfig(trialInfo.value));

export const reloadTrialInfoFromLiveCall = async () => {
  trialInfo.value = await getTrialInfoFromLiveCall();
};

watch(trialRenderConfig, (value) => {
  if (value?.isEligible && !value.isRides7Day) {
    void showWarningPopupDialog({
      text: value.warningDialog.text,
      title: value.warningDialog.title,
    });
  }
});

export const gourmetUsageOptions = [
  { value: 'one', label: 'One Time' },
  { value: 'multiple', label: 'Multiple Times' },
] as const;
export const gourmetOrderFrequencyOptions = [
  { value: '<1', label: 'Less than 1 or not sure' },
  { value: '1-2', label: '1-2' },
  { value: '3-4', label: '3-4' },
  { value: '5+', label: '5+' },
] as const;
export const gourmetUsage = ref<(typeof gourmetUsageOptions)[number]['value'] | ''>('');
export const gourmetUsageFrequency = ref<(typeof gourmetOrderFrequencyOptions)[number]['value'] | ''>('');

watch(gourmetUsage, (value: string) => {
  if (value === 'one') {
    gourmetUsageFrequency.value = '';
  }
});

export const gourmetUsageQqqGroup = ref<string | null>(null);
